import { createSelector } from '@base-ui/utils/store';
import { isInternalDragOrResizePlaceholder } from "../internals/utils/drag-utils.mjs";
export const schedulerOccurrencePlaceholderSelectors = {
  value: createSelector(state => state.occurrencePlaceholder),
  isDefined: createSelector(state => state.occurrencePlaceholder !== null),
  actionForOccurrence: createSelector((state, occurrenceKey) => {
    const placeholder = state.occurrencePlaceholder;
    if (isInternalDragOrResizePlaceholder(placeholder) && placeholder.occurrenceKey === occurrenceKey) {
      return placeholder.type;
    }
    return null;
  })
};